// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2-Usx","footer":"ReportModalFilter_footer__3aZi9"};